import { render, staticRenderFns } from "./loan-drop-out.vue?vue&type=template&id=d6b7d5da&"
import script from "./loan-drop-out.vue?vue&type=script&lang=js&"
export * from "./loan-drop-out.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports